import './Footer.css'
import ReactGA from "react-ga";

const EMAIL = "brittanysgotcake@gmail.com";

const trackOrderClick = () => {
  ReactGA.event({
	category: "CTA",
	action: "Click",
	label: "Order Now (Hero 2-Column)",
  });
};

const footer = () => (
	
<footer className="background-red white text-center">
	<h4>Brittany's Got Cake</h4>
	<p>Looking for something different? I also do custom orders! Price may vary depending on the order.</p>
	<a
		href={`mailto:${EMAIL}?subject=Cheesecake%20Order`}
		className="footer__cta"
		onClick={trackOrderClick}
		>
        Order Now
    </a>
</footer>
);


export default footer
